import React from "react";

export function CrossIcon(){
  return (
    <g>
      <path d="M19.7991 3.05176e-05L20.7419 0.942838L0.94289 20.7418L8.27312e-05 19.799L19.7991 3.05176e-05Z" fill="#ADADAD"/>
      <path d="M20.7418 19.799L19.799 20.7418L2.47121e-05 0.942798L0.942833 -1.04904e-05L20.7418 19.799Z" fill="#ADADAD"/>
    </g>
  )
}